import styled from 'styled-components'

export const ContainerWrapper = styled.div`
  margin: 0 auto;
  max-width: 1200px;
  box-sizing: border-box;
  padding: 0 20px 40px 20px;
`